import _ from "lodash";

const isDisabled = ({disabled=false, text=[]}) => {
    return disabled || _.isEmpty(text);
};

export default isDisabled;